import { useEffect } from "react";
import api from "../api/axiosConfig";

export default function useLiveLocation(userId) {
  useEffect(() => {
    if (!userId || !navigator.geolocation) return;

    let lastCoords = null;

    const updateLocation = () => {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const { latitude, longitude } = pos.coords;

          if (
            lastCoords &&
            Math.abs(latitude - lastCoords.lat) < 0.0001 &&
            Math.abs(longitude - lastCoords.lng) < 0.0001
          ) {
            return;
          }

          lastCoords = { lat: latitude, lng: longitude };

          api.post(`/users/${userId}/location`, {
            lat: latitude,
            lng: longitude,
          }).catch(() => {});
        },
        () => {},
        { enableHighAccuracy: false, maximumAge: 60000 }
      );
    };

    updateLocation();
    const interval = setInterval(updateLocation, 120000);

    return () => clearInterval(interval);
  }, [userId]);
}
